import { defineComponent as _defineComponent } from 'vue'
import { defineComponent } from 'vue';
    import BeachLineFilter from '@fr/vue/components/filters/beachLineFilter/BeachLineWrapperFilter.vue';
    import DistanceLiftFilter from '@fr/vue/components/filters/distanceLiftFilter/DistanceListFilterWrapper.vue';
    import BeachOwnerFilter from '@ve/components/filters/beachOwnerFilter/BeachOwnerFilterWrapper.vue';
    import { type HotelCategoryForFilter } from '@ve/components/filters/hotelCategoriesFilter/common/types';
    import FilterListItem from '@ve/components/searchFilters/filterList/desktop/FilterListItem.vue';
    import HotelCategoriesFilterList from '@ve/components/filters/hotelCategoriesFilter/desktop/HotelCategoriesFilterList.vue';
    import IsExclusiveFilterSerp from '@ve/components/filters/isExclusiveFilter/desktop/IsExclusiveFilterSerp.vue';
    import MealsFilterList from '@ve/components/filters/mealsFilter/desktop/MealsFilterList.vue';
    import NearCenterFilter from '@ve/components/filters/nearCenterFilter/NearCenterFilter.vue';
    import RatingReviewsFilter from '@ve/components/filters/ratingReviewsFilter/RatingReviewsFilterWrapper.vue';
    import { DirectFlightFilter } from '@features/tourProduct/filterTourProducts';
    import HotelsSearchWrapper from '@ve/components/searchFilters/filterList/desktop/components/hotelsSearchWrapper/HotelsSearchWrapper.vue';
    import FilterPostWrapper from '@ve/components/searchFilters/filterList/desktop/FilterPostWrapper.vue';
    import FiltersList from '@ve/components/searchFilters/filterList/desktop/FiltersList.vue';
    import FiltersListSection from '@ve/components/searchFilters/filterList/desktop/FiltersListSection.vue';
    import FiltersListSticky from '@ve/components/searchFilters/filterList/desktop/FiltersListSticky.vue';
    import FacilitiesFilter from '@ve/pages/serp/components/filters/facilitiesFilter/desktop/FacilitiesFilter.vue';
    import FilterWaterActivities from '@ve/pages/serp/components/filters/filterWaterActivities/deskop/FilterWaterActivities.vue';
    import ResortFilter from '@ve/pages/serp/components/filters/resortFilter/desktop/ResortFilterWrapper.vue';
    import useSerpFiltersTourProducts from '@widgets/serpToursProducts/lib/useSerpFiltersTourProducts';
    import { DesktopBudgetFilter } from '@features/filterByBudget/desktop';
    import { DesktopChildServiceFilter, DesktopRestTypeFilter, DesktopBeachTypeFilter } from '@features/hotel/filterHotels/desktop';
    import { DesktopFilterOperatorsAccordion } from '@features/operator/filterByOperator/desktop';
    import { EmiratesFilterCheckbox, isEmiratesAvailable, BonusMilesFilter } from '@features/tourProduct/filterTourProducts';
    import { RenovationFilter } from '@features/hotel/filterHotels/desktop';
    
export default /*#__PURE__*/_defineComponent({
  __name: 'DesktopSerpFilters',
  props: {
    categoriesList: null,
    resortVisible: { type: Boolean, default: true },
    directFlightVisible: { type: Boolean, default: true }
  },
  setup(__props: any) {

    defineComponent({ name: 'FiltersSerp' });

    

    const {
        groupedAllOperators,
        groupedFilteredOperators,
        filteredHotelsWithoutRestType,
        filteredHotelsWithoutBeachType,
        filteredHotelsWithoutRenovations,
        tourProductsPrices,
        isPopularityFilterActive,
        touristGroup,
        filteredHotels,
        allHotels,
        directFlightModel,
        searchCountries,
        searchDepartureCity,
        blockModel,
        isPairOfDepartureCityAndArrivalCountryAreValid,
        bonusMilesModel,
        isBonusMilesFilterVisible,
        operators,
    } = useSerpFiltersTourProducts();


return { __sfc: true,groupedAllOperators, groupedFilteredOperators, filteredHotelsWithoutRestType, filteredHotelsWithoutBeachType, filteredHotelsWithoutRenovations, tourProductsPrices, isPopularityFilterActive, touristGroup, filteredHotels, allHotels, directFlightModel, searchCountries, searchDepartureCity, blockModel, isPairOfDepartureCityAndArrivalCountryAreValid, bonusMilesModel, isBonusMilesFilterVisible, operators, BeachLineFilter, DistanceLiftFilter, BeachOwnerFilter, FilterListItem, HotelCategoriesFilterList, IsExclusiveFilterSerp, MealsFilterList, NearCenterFilter, RatingReviewsFilter, DirectFlightFilter, HotelsSearchWrapper, FilterPostWrapper, FiltersList, FiltersListSection, FiltersListSticky, FacilitiesFilter, FilterWaterActivities, ResortFilter, DesktopBudgetFilter, DesktopChildServiceFilter, DesktopRestTypeFilter, DesktopBeachTypeFilter, DesktopFilterOperatorsAccordion, EmiratesFilterCheckbox, isEmiratesAvailable, BonusMilesFilter, RenovationFilter }
}

})